export default "__VITE_ASSET__9aUvSScd__"